export default "__VITE_ASSET__4042d93c__$_?inline__"